import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;
import vuexStorage from '../store/index.js'

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction de récupération d'infos fournisseur de ligne à une propale
async function getInfosFournisseur(id){
    try {
        let response = await requestApi({method: 'GET', url: '/api/getInfosFournisseur?nocache=' + new Date().getTime(), params: {id:id}, form: {}, headers: {'Content-Type': 'application/json'}})
        return response
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de récupérer les informations du fournisseur`,'Récupération d\'informations')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

//Fonction de modification de ligne de propale
async function modifyLinePropale(idPropale,line,ref){
    try {
        await requestApi({method: 'POST', url: '/api/modifyLinePropale?nocache=' + new Date().getTime(), params: {}, form: {id:idPropale, line:line}, headers: {'Content-Type': 'application/json'}})
        await requestApi({method: 'POST', url: '/api/rebuildDocPropale?nocache=' + new Date().getTime(), params: {}, form: {ref:ref}, headers: {'Content-Type': 'application/json'}})
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de mettre à jour la ligne`,'Modification de ligne')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
    toasterError,
    toasterSuccess,
}